import { Component, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, ActivatedRoute, RouterModule, NavigationEnd } from '@angular/router';
import { filter, Subject, takeUntil } from 'rxjs';
import { ContractService } from 'src/app/services/contracts/contract.service';
import { PageNavigationService } from 'src/app/services/page-navigation.service';
import { HeaderTab } from 'src/app/components/page-nav-bar/page-nav-bar.component';
import { ViewToggleComponent } from 'src/app/components/view-toggle/view-toggle.component';
import { ActivityLogService } from 'src/app/services/activity-log.service';
import { ActivitySection } from 'src/app/constants/activity-log';

@Component({
    selector: 'app-site-contracts',
    imports: [CommonModule, RouterModule, ViewToggleComponent],
    templateUrl: './site-contracts.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ['./site-contracts.component.css']
})
export class SiteContractsComponent implements OnInit, OnDestroy {
  showViewToggle = false;
  siteId: number;
  siteDeadlineViews: any[] = [];

  private $unsubscribe = new Subject<void>();

  constructor(
    private contractService: ContractService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private pageNavService: PageNavigationService,
    private activityLog: ActivityLogService,
  ) {}

  private get basePath(): string {
    const segments: string[] = [];
    this.activatedRoute.pathFromRoot.forEach(route =>
      route.snapshot.url.forEach(s => segments.push(s.path))
    );
    return '/' + segments.join('/');
  }

  private get secondaryTabs(): HeaderTab[] {
    const base = this.basePath;
    return [
      { text: $localize`:@@allContracts:All contracts`, routerLink: `${base}/overview`, icon: 'contracts' },
      { text: $localize`:@@deadlines:Deadlines`, routerLink: `${base}/deadlines`, icon: 'calendar', activeRoutes: [`${base}/calendar`] },
    ];
  }

  private syncFilterToRoute(): void {
    const url = this.router.url;
    if (url.includes('/deadlines') || url.includes('/calendar')) {
      this.contractService.setFilterOptions(2);
      this.showViewToggle = true;
    } else {
      this.contractService.setFilterOptions(1);
      this.showViewToggle = false;
    }
  }

  async ngOnInit() {
    this.siteId = this.activatedRoute.snapshot.params['id'];
    this.activityLog.logView({ Section: ActivitySection.SITE_CONTRACTS, SiteId: Number(this.siteId) });

    const base = this.basePath;
    this.siteDeadlineViews = [
      { icon: 'list-view', routerLink: [`${base}/deadlines`], urlMatch: '/deadlines', tooltip: $localize`:@@showAsList:Show as list` },
      { icon: 'calendar',  routerLink: [`${base}/calendar`],  urlMatch: '/calendar',  tooltip: $localize`:@@showAsCalendar:Show as calendar` },
    ];

    this.pageNavService.setSecondaryTabs(this.secondaryTabs);

    const payload = { siteId: this.siteId };
    await this.contractService.getContracts(payload);
    await this.contractService.getDeadlines(payload);
    this.contractService.getProjects({});
    this.contractService.getContractTypes({});

    this.router.events
      .pipe(filter(e => e instanceof NavigationEnd), takeUntil(this.$unsubscribe))
      .subscribe(() => this.syncFilterToRoute());

    this.syncFilterToRoute();
  }

  ngOnDestroy(): void {
    this.pageNavService.clearSecondaryTabs();
    this.$unsubscribe.next();
    this.$unsubscribe.complete();
  }
}
